import Flickity from 'flickity';
import 'flickity-fade';
import 'flickity/css/flickity.css';

function StopVideos (){
    const videos = document.querySelectorAll('video');
    videos?.forEach((video) => {
        video.muted = true;
        video.pause();
    });
}

function PlayVideos (){
    const videos = document.querySelectorAll('.carousel-cell.is-selected video');
    videos?.forEach((video) => {
        video.muted = false;
        video.play();
    });
}




export const slideShow = () => {

    const slideShowCont = document.querySelector('.archives-slideshow');
    const sideMenu = document.querySelector('.side-menu');
    const trigger = document.querySelectorAll('.trigger-slideshow');

    trigger?.forEach((button) => {
        button.addEventListener('click', function (){
            const index = button.dataset.index
            console.log(index);
            window.Flkty.select(index, false, false);
            slideShowCont.classList.add('show');
            PlayVideos();
        });
    });

    const closeButton = document.querySelector('.close-slideshow');
    closeButton?.addEventListener('click', function (){
        slideShowCont.classList.remove('show');
        StopVideos();
    });

    if (window.Flkty) {
        window.Flkty.destroy();
        window.Flkty = null;
    /*    window.removeEventListener('resize', handleResize);*/
    }

    const flickityOptions = {
        cellAlign: 'center',
        contain: true,
        draggable: false,
        lazyLoad: 2,
        fade: true,
        wrapAround: true,
        autoPlay: false,
        pageDots: false,
        arrowShape: '',
        prevNextButtons: true,
        on: {
            ready: function () {
               
            },
            change: function (index) {

                const slideShowHeader = document.querySelector('.archives-slideshow .slideshow-header');
                const slideShowFooter = document.querySelector('.archives-slideshow .slideshow-footer');
                let activeSlide = window.Flkty.selectedElement;
                const activeIndex = activeSlide.dataset.index;
                const activeLegend = activeSlide.dataset.legend;

                StopVideos();
                const video = activeSlide.querySelector('video');
                if (video) {
                    video.play();
                    video.muted = false;
                }
                slideShowHeader.innerHTML = activeIndex;
                slideShowFooter.innerHTML = activeLegend;
            }
        }
    }
    const carousel = document.querySelector('.carousel');
    console.log(carousel);
    if(carousel){
        window.Flkty = new Flickity(carousel, flickityOptions);
        console.log(window.Flkty);
    }


}


